import LogInModal from 'flarum/forum/components/LogInModal';

function finishUrl(state) {
  return '/feedback-auth' + (state ? '?state=' + encodeURIComponent(state) : '');
}

function redirectWhenSignedIn(url) {
  if (app.session && app.session.user) {
    window.location.assign(url);
    return;
  }

  const startedAt = Date.now();
  const timer = window.setInterval(() => {
    if (app.session && app.session.user) {
      window.clearInterval(timer);
      window.location.assign(url);
      return;
    }

    if (Date.now() - startedAt > 10 * 60 * 1000) {
      window.clearInterval(timer);
    }
  }, 500);
}

app.initializers.add('objo-feedback-auth', () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('feedbackAuth') !== '1') return;

  const url = finishUrl(params.get('state') || '');

  if (app.session && app.session.user) {
    window.location.assign(url);
    return;
  }

  window.setTimeout(() => {
    app.modal.show(LogInModal);
    redirectWhenSignedIn(url);
  }, 0);
});
